import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ContextMenuModule} from "primeng/contextmenu";
import {CardModule} from 'primeng/card';
import {ButtonModule} from 'primeng/button';
import { SvgMapComponent } from './svg-map/svg-map.component';
import {SimpleStatComponent} from './simple-stat/simple-stat.component';
import { SvgEventIconComponent } from './svg-icon/svg-icon.component';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import { DialogModule } from 'primeng/dialog';
import { StepsModule } from 'primeng/steps';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    SvgMapComponent,
    SimpleStatComponent,
    SvgEventIconComponent
  ],
  exports: [
    SvgMapComponent,
    SimpleStatComponent,
    SvgEventIconComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ProgressSpinnerModule,
    ContextMenuModule,
    CardModule,
    TagModule,
    BadgeModule,
    ButtonModule,
    DialogModule,
    StepsModule,
    DropdownModule,
  ],
})
export class XRackSharedModule {}
